export const PanelClientsEditPublicProfilePictureMessages = {
    TypeName: {
        key: 'TypeName',
        message: 'Public Profile Picture'
    },
    Subtype: {
        key: 'Subtype',
        message: 'Profile image'
    },
    Description: {
        key: 'Description',
        message: 'Client-level public trader image'
    },
    StatusActive: {
        key: 'StatusActive',
        message: 'Active'
    },
    StatusNone: {
        key: 'StatusNone',
        message: 'None'
    },
    RemoveNote: {
        key: 'RemoveNote',
        message: 'Remove \u2192 initials avatar on all published portfolios; immediate; audited; no client notification.'
    },
    GetPictureFailed: {
        key: 'GetPictureFailed',
        message: 'Error while communication with the server. Can\'t load the public profile picture.'
    },
    PreviewFailed: {
        key: 'PreviewFailed',
        message: 'The picture could not be loaded for preview.'
    },
    InvalidFormat: {
        key: 'InvalidFormat',
        message: 'Only JPEG and PNG pictures can be uploaded.'
    },
    ReplaceSucceeded: {
        key: 'ReplaceSucceeded',
        message: 'The public profile picture was replaced.'
    },
    ReplaceTooLarge: {
        key: 'ReplaceTooLarge',
        message: 'The picture is larger than 10 MB.'
    },
    ReplaceNotAnImage: {
        key: 'ReplaceNotAnImage',
        message: 'The file is not a readable JPEG or PNG, or it has more than 24 megapixels.'
    },
    ReplaceConflict: {
        key: 'ReplaceConflict',
        message: 'The picture was changed at the same time by someone else; the card shows the current picture.'
    },
    ReplaceFailed: {
        key: 'ReplaceFailed',
        message: 'Error while communication with the server. The picture could not be replaced.'
    },
    RemoveCaption: {
        key: 'RemoveCaption',
        message: 'Remove the public profile picture?'
    },
    RemoveQuestion: {
        key: 'RemoveQuestion',
        message: 'The initials avatar replaces the picture of <b><<name>></b> on all of the client\'s published portfolios immediately. '
            + 'The client is not notified. This action is audited.'
    },
    RemoveButton: {
        key: 'RemoveButton',
        message: 'Remove'
    },
    RemoveSucceeded: {
        key: 'RemoveSucceeded',
        message: 'The public profile picture was removed.'
    },
    RemoveFailed: {
        key: 'RemoveFailed',
        message: 'Error while communication with the server. The picture could not be removed.'
    },
    CommandNotConfirmed: {
        key: 'CommandNotConfirmed',
        message: 'The server did not confirm the change; the card shows the current picture.'
    },
    Unavailable: {
        key: 'Unavailable',
        message: 'The public profile picture is not available for this client.'
    },
    RelatedBadge: {
        key: 'RelatedBadge',
        message: 'Public'
    }
};
